<template>
  <div class="proj-auth-box">
    <div
      class="proj-list-box"
      :class="expandedArrow ? '' : 'openTree'">
      <div
        class="proj-list-box-tree"
        v-show="expandedArrow">
        <div class="title-box">
          <div class="symbol" />
          <div class="name">项目列表</div>
        </div>
        <div class="common-input-box">
          <el-input
            v-show="expandedArrow"
            class="input-primary"
            size="mini"
            v-model="projNameInput"
            placeholder="请输入项目名称"
            clearable
            @clear="searchProj"
            @keyup.enter.native="searchProj">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="searchProj" />
          </el-input>
        </div>
        <div
          class="proj-list-data-box"
          v-show="expandedArrow">
          <div v-if="isProjListloading">
            <Spin
              :pointNum="8"
              :translateX="25"
              background="var(--base-primary-bgColor)" />
          </div>
          <div
            class="list-box"
            v-if="!isProjListloading && projList.length">
            <div
              v-for="(item, index) in projList"
              :key="index"
              :class="`list-item-box ${isProjActive(item) ? 'active' : ''}`"
              @click="handleProjClick(item)">
              <div
                class="text-overflow"
                :title="item.projectName">
                {{ item.projectName }}
              </div>
            </div>
          </div>
          <div
            v-if="!isProjListloading && !projList.length"
            class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="text-box empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </div>
      </div>
      <div
        class="expaned"
        @click="() => (expandedArrow = !expandedArrow)">
        <i
          v-if="!expandedArrow"
          size="14"
          class="el-icon-arrow-right el-icon"></i>
        <i
          v-else
          size="14"
          class="el-icon-arrow-left el-icon"></i>
      </div>
    </div>
    <div
      class="sub-user-box outer-page-primary"
      :style="{ width: expandedArrow ? 'calc(100% - 276px)' : '100%' }">
      <div v-if="isProjListloading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="header-box"
        v-if="!isProjListloading">
        <div class="title-box">
          <div class="symbol" />
          <div class="title">管理人员列表</div>
        </div>
      </div>
      <div
        class="operation-box"
        v-if="!isProjListloading">
        <div class="common-button-box">
          <el-button
            class="primary-btn"
            v-if="isChecked('Project.ManagerManage.Add')"
            type="primary"
            size="small"
            :disabled="!projList.length"
            @click="openManagerDialog">
            添加管理人员
          </el-button>
          <el-button
            class="normal-btn"
            v-if="isChecked('Project.ManagerManage.BatchDelete')"
            size="small"
            @click="batchRelieveRelation">
            批量移除
          </el-button>
        </div>
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box searchLabel">用户名：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入用户名称"
                v-model="userName" />
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">手机号：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入手机号"
                v-model="phone" />
            </div>
          </div>
          <div class="common-button-box">
            <el-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="searchManager">
              查询
            </el-button>
            <el-button
              size="small"
              class="normal-btn"
              @click="resetFilter"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="manager-list-box"
        v-if="!isProjListloading">
        <div class="common-table-box">
          <el-table
            :data="managerList"
            height="100%"
            class="publish-table"
            highlight-selection-row
            @select="selectChange"
            @select-all="selectChange"
            ref="tableGroup"
            :header-row-class-name="customHeaders">
            <el-table-column
              type="selection"
              width="60" />
            <el-table-column
              label="序号"
              type="index"
              width="55" />
            <el-table-column
              label="用户名"
              prop="userName" />
            <el-table-column
              label="手机号"
              prop="phoneNumber" />
            <el-table-column label="邮箱">
              <template #default="{ row }">
                {{ row?.email || '--' }}
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="name" />
            <el-table-column label="公司">
              <template #default="{ row }">
                {{ row?.company || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="企业类型">
              <template #default="{ row }">
                {{ row?.enterpriseType || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="职位">
              <template #default="{ row }">
                {{ row?.position || '--' }}
              </template>
            </el-table-column>
            <el-table-column
              label="角色"
              prop="roleName" />
            <el-table-column
              v-if="isChecked('Project.ManagerManage.Delete')"
              label="操作"
              width="120">
              <template v-slot="{ row }">
                <div class="common-button-box operation-cell">
                  <el-button
                    v-if="isChecked('Project.ManagerManage.Delete')"
                    @click="relieveRelation(row)"
                    type="text"
                    size="small">
                    移除
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="empty-box empty-page">
                <bj-empty
                  :image="require('@/assets/img/no-data.png')"
                  class="empty-page">
                  <template slot="description">
                    <span class="empty-text"
                      >抱歉，没有找到相关内容</span
                    ></template
                  >
                </bj-empty>
              </div>
            </template>
          </el-table>
        </div>
        <div class="common-pagination-box">
          <el-pagination
            class="pagination-primary"
            popper-class="common-pagination-popper-box"
            layout="sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100, 150, 200]"
            :page-size="pageSize"
            :current-page="currPage"
            :total="total"
            @size-change="sizeChange"
            @current-change="pageChange" />
        </div>
      </div>
    </div>
    <UserRelationDialog
      v-if="isManagerDialogVisible"
      :visible="isManagerDialogVisible"
      :userList="unBindUserList"
      :search="searchUnBindUserList"
      :submitRequest="createProjectUserRelation"
      :closeDialog="closeManagerDialog" />
    <DragDialog
      title="项目移交"
      :width="360"
      :visible.sync="isTransferDialogVisible"
      :footerBtn="['cancel', 'submit']"
      :submit="submitTransfer"
      :cancel="closeTransferDialog">
      <div class="proj-transfer-box">
        <div class="user-input-box">
          <div class="label-box">移交给:</div>
          <div class="common-input-box">
            <el-input
              size="small"
              v-model="userFilterInput"
              placeholder="请输入用户名或手机号"
              clearable
              @clear="searchUser"
              @keyup.enter.native="searchUser">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="searchUser" />
            </el-input>
          </div>
        </div>
        <div class="user-list-box">
          <div
            v-for="(item, index) in userList"
            :key="index"
            class="user-item-box">
            <span>{{ item.surName }}</span>
            <div class="icon-box">
              <i
                class="el-icon-error icon"
                @click="removeUser(item)" />
            </div>
          </div>
        </div>
      </div>
    </DragDialog>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'
import UserRelationDialog from '@/components/UserRelationDialog.vue'
import { customHeaderStyle } from '@/utils/index.js'
import { Store } from '@/utils/store'

import {
  getOptionalProjListService,
  getUserProjRelationListService,
  getProjUnBindUserListService,
  createProjUserRelationService,
  removeProjManagerCheckService,
  delProjUserRelationService,
  batchDelProjUserRelationService,
  getNewProjManagerService,
  handoverProjService
} from '@/service/interface'

export default {
  data() {
    return {
      isProjListloading: false,
      projNameInput: '',
      projList: [],
      selectProjInfo: {},
      expandedArrow: true,
      userName: '',
      phone: '',
      currPage: 1,
      pageSize: 10,
      total: 0,
      managerList: [],
      selectManagers: [],
      customHeaders: '',
      isManagerDialogVisible: false,
      unBindUserList: [],

      isTransferDialogVisible: false,
      projIdToHandover: '',
      userFilterInput: '',
      userList: []
    }
  },
  components: {
    Spin,
    DragDialog,
    UserRelationDialog
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.tableGroup?.bodyWrapper
      const _this = this
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          _this.customHeaders = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 500)
    this.initProjList()
  },
  methods: {
    initProjList() {
      this.isProjListloading = true
      this.queryProjList().then(projList => {
        this.projList = projList
        if (projList.length) {
          let defaultProjInfo = projList[0]
          this.handleProjClick(defaultProjInfo)
        }

        this.isProjListloading = false
      })
    },
    searchProj() {
      this.isProjListloading = true
      this.queryProjList().then(projList => {
        this.projList = projList

        this.isProjListloading = false
      })
    },
    handleProjClick(projInfo) {
      this.selectProjInfo = projInfo
      this.queryProjRelationUserList().then(managerList => {
        this.managerList = managerList
      })
    },
    updateUserList() {
      return new Promise(resolve => {
        this.queryProjRelationUserList().then(managerList => {
          this.managerList = managerList
          resolve()
        })
      })
    },
    searchManager() {
      this.queryProjRelationUserList().then(managerList => {
        this.managerList = managerList
      })
    },
    resetFilter() {
      this.userName = ''
      this.phone = ''
    },
    openManagerDialog() {
      this.queryProjUnBindUserListList().then(unBindUserList => {
        this.unBindUserList = unBindUserList

        this.isManagerDialogVisible = true
      })
    },
    searchUnBindUserList(userName, phone) {
      this.queryProjUnBindUserListList(userName, phone).then(unBindUserList => {
        this.unBindUserList = unBindUserList
      })
    },
    createProjectUserRelation(userIds) {
      return new Promise(resolve => {
        let params = {
          projectId: this.selectProjInfo.projectId,
          userIds
        }
        createProjUserRelationService(params).then(response => {
          if (response.isSuccess) {
            this.updateUserList().then(() => {
              this.$message.success('添加用户关系成功')
              resolve()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closeManagerDialog() {
      this.isManagerDialogVisible = false
    },
    openTransferDialog() {
      this.isTransferDialogVisible = true
    },
    searchUser() {
      if (!this.userFilterInput) {
        this.$message.warning('请输入用户名或手机号')
        return
      }
      let params = {
        input: this.userFilterInput
      }
      getNewProjManagerService(params).then(response => {
        if (response.isSuccess) {
          let surnameData = response.data
          this.handleSearchResult(surnameData)
        } else {
          this.$message.error('用户不存在，请重新输入！！！')
          this.userFilterInput = ''
        }
      })
    },
    removeUser(userInfo) {
      let findIndex = this.userList.findIndex(el => el.id === userInfo.id)
      this.userList.splice(findIndex, 1)
      this.userFilterInput = ''
    },
    handleSearchResult(data) {
      let find = this.userList.find(el => el.id === data.userId)
      if (!find) {
        this.userList = []
        let userInfo = {
          id: data.userId,
          surName: data.surName ? data.surName : data.userName
        }
        this.userList.push(userInfo)
      } else {
        this.$message.error('已选择该用户，请重新输入！！！')
        this.userFilterInput = ''
      }
    },
    submitTransfer() {
      if (!this.userList.length) {
        this.$message.warning('请先指定项目移交人员')
        return
      }
      let params = {
        projectId: this.projIdToHandover,
        userId: this.userList[0].id
      }
      handoverProjService(params).then(response => {
        if (response.isSuccess) {
          this.updateUserList().then(() => {
            this.searchProj()
            this.$message.success('移交成功!')

            this.closeTransferDialog()
          })
        } else {
          this.$message.error(response.errMsg)
          this.closeTransferDialog()
        }
      })
    },
    closeTransferDialog() {
      this.projIdToHandover = ''
      this.userFilterInput = ''
      this.userList = []
      this.isTransferDialogVisible = false
    },
    relieveRelation(userInfo) {
      let projectId = this.selectProjInfo.projectId
      let userId = userInfo.userId
      let params = { projectId, userId }
      removeProjManagerCheckService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data && data.includes('可以直接移除')) {
            this.$confirm('确定移除用户？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                delProjUserRelationService(params).then(response => {
                  if (response.isSuccess) {
                    this.updateUserList().then(() => {
                      this.searchProj()
                      this.$message.success('用户移除成功')
                    })
                  } else {
                    this.$message.error(response.errMsg)
                  }
                })
              })
              .catch(() => {
                this.$message.info('取消移除')
              })
          } else {
            this.projIdToHandover = projectId
            this.openTransferDialog()
          }
        } else {
          let warningMsg = response.errMsg
          this.$confirm(warningMsg, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          })
        }
      })
    },
    batchRelieveRelation() {
      if (!this.selectManagers.length) {
        this.$message.warning('请选择需要移除的用户')
        return
      }

      if (this.selectManagers.length === 1) {
        let projectId = this.selectProjInfo.projectId
        let userId = this.selectManagers[0].userId
        let params = { projectId, userId }
        removeProjManagerCheckService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data && data.includes('可以直接移除')) {
              this.$confirm('确定移除用户？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  delProjUserRelationService(params).then(res => {
                    if (res.isSuccess) {
                      this.updateUserList().then(() => {
                        this.searchProj()
                        this.$message.success('用户移除成功')
                      })
                    } else {
                      this.$message.error(res.errMsg)
                    }
                  })
                })
                .catch(() => {
                  this.$message.info('取消移除')
                })
            } else {
              this.projIdToHandover = projectId
              this.openTransferDialog()
            }
          } else {
            let warningMsg = response.errMsg
            this.$confirm(warningMsg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning'
            })
          }
        })
        return
      }

      this.$confirm('确定移除用户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let userIds = this.selectManagers.map(item => item.userId)
          let params = {
            projectId: this.selectProjInfo.projectId,
            userIds
          }
          batchDelProjUserRelationService(params).then(response => {
            if (response.isSuccess) {
              this.updateUserList().then(() => {
                this.searchProj()
                this.$message.success('用户移除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          this.$message.info('取消移除用户')
        })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.updateUserList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.updateUserList()
    },
    selectChange(selectManagers) {
      this.selectManagers = selectManagers
    },
    queryProjList() {
      return new Promise(resolve => {
        let projectName = this.projNameInput
        getOptionalProjListService({ projectName }).then(response => {
          if (response.isSuccess) {
            let projList = response.data
            resolve(projList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryProjRelationUserList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize,
          projectId: this.selectProjInfo.projectId,
          userName: this.userName,
          phone: this.phone
        }
        getUserProjRelationListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let managerList = data.items
            this.total = data.totalCount
            resolve(managerList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryProjUnBindUserListList(userName, phone) {
      return new Promise(resolve => {
        let projectId = this.selectProjInfo.projectId
        let params = { projectId, userName, phone }
        getProjUnBindUserListService(params).then(response => {
          if (response.isSuccess) {
            let unBindUserList = response.data
            resolve(unBindUserList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isProjActive(projInfo) {
      return this.selectProjInfo.projectId === projInfo.projectId
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.proj-auth-box {
  display: flex;
  justify-content: space-between;
  height: 100%;
  text-align: left;
  padding-top: 0;
  .expaned {
    width: 24px;
    height: 40px;
    border-radius: 16px;
    background-color: var(--aside-arrow-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border: 1px solid var(--aside-arrow-bgColor);
    position: absolute;
    top: 50%;
    left: 246px;
    transform: translateY(-50%);
    display: none;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background-color: var(--aside-arrow-hover-bgColor);
      box-shadow: var(--base-bg-dark-color30);
      border-color: transparent;
      border-radius: 16px;
    }

    .el-icon {
      font-weight: 600;
      color: var(--aside-arrow-expand-icon-color);
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
  .openTree {
    width: 0 !important;
    padding: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    border: none;
    .expaned {
      left: -12px !important;
      z-index: 9;
      display: block !important;
    }
  }
  .proj-list-box-tree {
    height: 100%;
  }
  .proj-list-box {
    width: 260px;
    height: 100%;
    padding: 16px;
    border-radius: 16px;
    background-color: var(--aside-page-bgColor);
    margin-right: 16px;
    transition: all 0.3s;
    position: relative;

    &:hover {
      .expaned {
        display: block;
      }
    }

    .title-box {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .symbol {
        width: 4px;
        height: 20px;
        border-radius: 4px;
        background: var(--base-primary-bgColor);
      }

      .name {
        margin-left: 8px;
        color: var(--page-title-color);
      }
    }

    .common-input-box {
      // margin: 20px 0px 20px 15px;
      margin-bottom: 16px;
    }

    .proj-list-data-box {
      position: relative;
      height: calc(100% - 90px);

      .list-box {
        height: 100%;
        overflow-y: auto;

        .list-item-box {
          padding: 5px 20px;
          border-radius: 4px;
          cursor: pointer;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 400;
          color: var(--tree-node-text-color);

          &:not(:last-child) {
            margin-bottom: 4px;
          }

          &:hover {
            background: var(--tree-item-hover-color);
          }
        }

        .active {
          color: var(--base-primary-color);
          background: var(--base-bg-light-color24);
        }
      }

      .common-empty-box {
        .text-box {
          margin: auto;
          color: var(--normal-status-color);
          font-size: 14px;
        }
      }
    }
  }

  .sub-user-box {
    flex-grow: 1;
    height: 100%;
    padding: 16px;
    border-radius: 16px;
    transition: all 0.3s;

    .header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0;
      padding-top: 0;

      .title-box {
        display: flex;
        align-items: center;

        .symbol {
          width: 4px;
          height: 20px;
          border-radius: 4px;
          background: var(--base-primary-bgColor);
        }

        .title {
          margin-left: 10px;
          color: var(--page-title-color);
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: space-between;
      padding: 0;

      .filter-box {
        display: flex;

        .filter-item-box {
          display: flex;
          align-items: center;
          margin-left: 15px;
        }

        .common-button-box {
          .el-button {
            margin-left: 15px;
            margin-right: 0px;
          }
        }
      }
    }

    .manager-list-box {
      height: calc(100% - 88px);

      .pagination-primary {
        margin-left: -15px;
      }
      .common-table-box {
        height: calc(100% - 48px);
      }
    }
  }
}

.proj-transfer-box {
  color: var(--default-color);

  .user-input-box {
    display: flex;
    align-items: center;

    .common-input-box {
      flex-grow: 1;
      margin-left: 5px;
    }
  }

  .user-list-box {
    margin: 10px 0px 0px 55px;
    .user-item-box {
      display: inline-flex;
      align-items: center;
      border-radius: 20px;
      padding: 2px 10px;
      border: 1px solid var(--base-border-dark-color8);

      .icon-box {
        font-size: 14px;
        margin-left: 5px;
        color: var(--base-light-color11);
        cursor: pointer;
      }
    }
  }
}
</style>
